import api from '../lib/api';

export function mapNotification(n) {
  return { ...n, recipientId: n.userId || null };
}

export function mapMerchant(m) {
  return { ...m, category: (m.categories || [])[0] || 'Others' };
}

export function merchantToApplication(m) {
  return {
    id: m.merchantId, merchantId: m.merchantId, businessName: m.name, name: m.name,
    email: m.ownerEmail || '', phone: m.phone || '', plan: m.plan, billing: m.billing,
    price: m.planPrice, categories: m.categories || [], district: m.district, address: m.address,
    whatsapp: m.whatsapp, bank: m.bank || {}, status: m.status, createdAt: m.createdAt,
  };
}

export function mapPlanRequest(r) {
  return { ...r, from: r.fromPlan, to: r.toPlan, requestedAt: r.createdAt };
}

export async function fetchPublic() {
  const [settings, merchants, products, partners, vouchers] = await Promise.all([
    api.get('/settings/public'), api.get('/merchants'), api.get('/products'), api.get('/partners'), api.get('/vouchers'),
  ]);
  return {
    deliverySettings: settings.data.deliverySettings,
    campaign: settings.data.campaign,
    referralProgram: settings.data.referralProgram,
    madeInKelantan: settings.data.madeInKelantan,
    homeHero: settings.data.homeHero,
    homeLayout: settings.data.homeLayout,
    customMerchants: merchants.data.map(mapMerchant),
    customProducts: products.data,
    partners: partners.data,
    vouchers: vouchers.data,
  };
}

export async function fetchRole(user) {
  const patch = {};
  if (user.role === 'consumer' || user.role === 'merchant') {
    const reqs = [
      api.get('/orders/my'), api.get('/wallet/my'), api.get('/tickets/my'),
      api.get('/notifications'), api.get('/referrals/my'),
    ];
    const [orders, wallet, tickets, notifs, referrals] = await Promise.all(reqs);
    const key = user.role === 'merchant' ? user.merchantId : user.email;
    patch.orders = orders.data;
    patch.wallets = { [key]: wallet.data.balance };
    patch.walletTransactions = wallet.data.transactions;
    patch.topUpRequests = wallet.data.requests;
    patch.supportTickets = tickets.data;
    patch.notifications = notifs.data.map(mapNotification);
    patch.referralUses = referrals.data.uses;
  }
  if (user.role === 'merchant') {
    const [mine, orders, vouchers, payouts] = await Promise.all([
      api.get('/merchants/mine').catch(() => ({ data: null })),
      api.get('/merchant/orders'),
      api.get('/merchant/vouchers'),
      api.get('/merchant/payouts'),
    ]);
    patch.orders = orders.data;
    patch.payouts = payouts.data;
    if (mine.data) {
      patch._myStore = mapMerchant(mine.data);
      const byCode = {};
      [...(patch.vouchers || []), ...vouchers.data].forEach((v) => { byCode[v.code] = v; });
      patch.vouchers = Object.values(byCode);
    }
  }
  if (user.role === 'rider') {
    const [jobs, cash, notifs] = await Promise.all([
      api.get('/rider/jobs'), api.get('/rider/cash'), api.get('/notifications'),
    ]);
    patch.deliveries = jobs.data;
    patch.cashEntries = cash.data;
    patch.notifications = notifs.data.map(mapNotification);
  }
  if (user.role === 'admin') {
    const [merchants, orders, deliveries, cash, digital, payouts, planReqs, topups, txns, walletAll, tickets, audit, referrals, notifs] = await Promise.all([
      api.get('/admin/merchants'), api.get('/admin/orders'), api.get('/admin/deliveries'),
      api.get('/admin/finance/cash'), api.get('/admin/finance/digital'), api.get('/admin/payouts'),
      api.get('/admin/plan-requests'), api.get('/admin/wallet/requests'), api.get('/admin/wallet/transactions'),
      api.get('/admin/wallet/all'), api.get('/admin/tickets'), api.get('/admin/audit-log'),
      api.get('/admin/referrals'), api.get('/notifications'),
    ]);
    patch.adminMerchants = merchants.data.map(mapMerchant);
    patch.customMerchants = merchants.data.filter((m) => m.status === 'APPROVED').map(mapMerchant);
    patch.applications = merchants.data.filter((m) => m.status !== 'APPROVED').map(merchantToApplication);
    patch.orders = orders.data;
    patch.deliveries = deliveries.data;
    patch.cashEntries = cash.data;
    patch.digitalCollections = digital.data;
    patch.payouts = payouts.data;
    patch.planRequests = planReqs.data.map(mapPlanRequest);
    patch.topUpRequests = topups.data;
    patch.walletTransactions = txns.data;
    patch.wallets = Object.fromEntries(walletAll.data.map((w) => [w.ownerKey, w.balance]));
    patch.supportTickets = tickets.data;
    patch.auditLog = audit.data;
    patch.referralUses = referrals.data;
    patch.notifications = notifs.data.map(mapNotification);
  }
  if (patch._myStore) {
    const myStore = patch._myStore;
    delete patch._myStore;
    patch.customMerchants = [myStore, ...(patch.customMerchants || []).filter((m) => m.id !== myStore.id)];
  }
  return patch;
}
